module.exports = __webpack_public_path__ + "img/logo_icon@2x.d2dfd045.png";